import { useState } from 'react';
import { useDocumentTitle } from '../common';
import { TeamTabs } from '.';

export const Team = () => {
  useDocumentTitle({ title: 'Registrants and Coordinators' });

  const [currentTab, setCurrentTab] = useState(0);

  return <TeamTabs currentTab={currentTab} setCurrentTab={setCurrentTab} />;
};
